import { render, staticRenderFns } from "./PasswordChangedView.vue?vue&type=template&id=43453e46&"
import script from "./PasswordChangedView.vue?vue&type=script&lang=js&"
export * from "./PasswordChangedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports